import React from 'react'

import { H5 } from '@hub/heading'
import { Stack } from '@hub/stack'
import { Text } from '@hub/text'

import { IParkingVehicle } from '../../types/parking-profile'

type Props = {
  vehicles: IParkingVehicle[]
}

const NumberPlates: React.FC<React.PropsWithChildren<Props>> = ({
  vehicles,
}) => (
  <Stack gap={'spacing-md'}>
    <H5>{`Number plate${vehicles.length > 1 ? 's' : ''}:`}</H5>
    <Stack as={'ul'} fontSize={'font-sm'}>
      {vehicles.map(vehicle => (
        <Text lineHeight={'base'} key={vehicle.plate}>
          {`${vehicle.plate} (Registered in ${vehicle.registeredIn})`}
        </Text>
      ))}
    </Stack>
    <Text
      fontSize={'font-sm'}
      lineHeight={'base'}
      sx={{ marginBottom: 'spacing-md' }}
    >
      To manage your number plates, go to Parking in the Westfield app.
    </Text>
  </Stack>
)

export default NumberPlates
